module.exports = __webpack_public_path__ + "img/error-404.0d5b1f19.png";